export default __webpack_public_path__ + "media/images/ea-master-2022-sponsor-2535d7f12e71375e1c8a4548b695a3b2.png";